<template>
  <b-form-input
    v-on="$listeners"
    :id="id"
    type="number"
    :autofocus="autofocus"
    :placeholder="placeholder"
    v-model.number="_dataModel"
    :max="maxValue"
    :min="minValue"
    @input="onInput"
    @keydown="onKeyDown"
    :class="[
      state ? 'border-danger bg-danger-outline' : ''
    ]"
    @paste="onPaste"
    @blur="onBlur"
  />
</template>

<script>
// Key code will be blocked as numeric input
const KEY_E = 69
const KEY_DASH = 189
const KEY_COMMA = 188
const KEY_PERIOD = 190
const KEY_EQUAL_SIGN = 187
const KEY_NUMPAD_SUBTRACT = 109
const KEY_NUMPAD_ADD = 107
const KEY_NUMPAD_DECIMAL = 110
export default {
  data() {
    return {
      keyCodeList: [
        KEY_E,
        KEY_DASH,
        KEY_COMMA,
        KEY_PERIOD,
        KEY_EQUAL_SIGN,
        KEY_NUMPAD_SUBTRACT,
        KEY_NUMPAD_ADD,
        KEY_NUMPAD_DECIMAL
      ],
      inputNumberValue: null
    }
  },
  model: {
    prop: 'dataModel',
    event: 'change'
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    maxValue: {
      type: Number,
      default: null
    },
    minValue: {
      type: Number,
      default: 0
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    dataModel: {
      type: Number | String,
      default: null
    },
    state: {
      type: Boolean,
      default: null
    },
    placeholder: {
      type: Number | String,
      default: null
    },
    constrainedMinValue: {
      type: Number,
      required: false
    },
    constrainedMaxValue: {
      type: Number,
      required: false
    },
    startField: {
      type: Boolean
    },
    endField: {
      type: Boolean
    }
  },
  computed: {
    _dataModel: {
      get() {
        return this.dataModel
      },
      set(value) {
        if (value === 0 || value) {
          this.inputNumberValue = value
        }
        this.$emit('change', value)
      }
    }
  },
  mounted() {
    setTimeout(() => {
      this.inputNumberValue = this.dataModel
    }, 10)
  },
  methods: {
    /**
     * 入力フィールドがフォーカスを失ったとき
     * @param {Event} event それはイベントです
     */
    onBlur(event) {
      // starField、endField が true の場合、条件付きで入力フィールドを検証します
      if (this.startField || this.endField) {
        this.$emit('onBlur', this.id, this._dataModel, this.validateInputField(event))
      } else if (this.inputNumberValue !== 0 && !this.inputNumberValue) {
        document.getElementById(this.id).value = ''
        return
      }
      this._dataModel = this.inputNumberValue
    },
    onPaste(e) {
      var clipboardData, pastedData
      clipboardData = e.clipboardData || window.clipboardData
      pastedData = clipboardData.getData('Text')
      // Prevent copied characters that are not numeric or negative
      if (!pastedData.match(/^[0-9]+$/)) {
        e.stopPropagation()
        e.preventDefault()
        return false
      }
    },
    onKeyDown(e) {
      if (this.keyCodeList.includes(e.keyCode)) {
        e.preventDefault()
        e.stopPropagation()
      }
    },
    onInput(e) {
      this.validateWarningMessage(this.id, this.maxValue, this.minValue, e)
      // Processing input value greater than max will return max
      if (this.maxValue && parseInt(e) > parseInt(this.maxValue)) {
        setTimeout(() => {
          this._dataModel = parseInt(this.maxValue)
        }, 10)
      }
      // Processing input value greater than max will return min
      if (parseInt(e) < parseInt(this.minValue)) {
        setTimeout(() => {
          this._dataModel = parseInt(this.minValue)
        }, 10)
      }
    },
    validateWarningMessage(nameField, maxValue, minValue, value) {
      // get element dom input field number
      const input = document.getElementById(nameField)
      const validityState = input.validity
      if (validityState.rangeUnderflow) {
        // Display warning message when value is less than min
        input.setCustomValidity(`値は${minValue - 1}以下にすることはできません。${minValue}に変更しました。`)
      } else if (validityState.rangeOverflow && maxValue) {
        // Display warning message when value is greater than max
        input.setCustomValidity(`値は${maxValue + 1}以上にすることはできません。${maxValue}に変更しました。`)
      } else {
        input.setCustomValidity('')
      }

      // Set value after validate number field full width character
      if (!validityState.badInput) {
        this.inputNumberValue = value
        if (this.inputNumberValue && parseInt(this.inputNumberValue) < minValue) {
          document.getElementById(nameField).value = parseInt(minValue).toString().trim()
        }
      }
      input.reportValidity()
    },
    /**
     * 入力フィールドを条件付きで検証し、エラーがある場合は警告メッセージを表示します
     * @param {Event} event それはイベントです
     */
    validateInputField(event) {
      if (!event && !event.target) {
        return
      }
      const targetElement = event.target
      const fieldValue = parseInt(targetElement.value)
      let warningMessage = ''
      if (!fieldValue || (this.endField && fieldValue < this.constrainedMinValue)) {
        warningMessage = `値は${this.constrainedMinValue - 1}以下にすることはできません。${this.constrainedMinValue}に変更しました。`
        this._dataModel = this.constrainedMinValue
      } else if (this.startField && fieldValue > this.constrainedMaxValue) {
        warningMessage = `値は${this.constrainedMaxValue + 1}以上にすることはできません。${this.constrainedMaxValue}に変更しました。`
        this._dataModel = this.constrainedMaxValue
      }
      targetElement.setCustomValidity(warningMessage)
      const isValidInputField = warningMessage.length === 0
      if (!isValidInputField) {
        targetElement.reportValidity()
      }
      return isValidInputField
    }
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/custom-components/InputNumberComponent.vue